import { action, makeObservable, observable } from 'mobx'

export class CapacitySettingsStore {
  allocationRuleWarningThreshold: number | null = null
  blockWarningThreshold: number | null = null
  yardWarningThreshold: number | null = null

  constructor() {
    makeObservable(this, {
      allocationRuleWarningThreshold: observable,
      blockWarningThreshold: observable,
      yardWarningThreshold: observable,
      setThresholds: action,
    })
  }

  setThresholds = (thresholds: {
    allocationRule: number | null
    block: number | null
    yard: number | null
  }) => {
    this.allocationRuleWarningThreshold = thresholds.allocationRule
    this.blockWarningThreshold = thresholds.block
    this.yardWarningThreshold = thresholds.yard
  }
}
